import xhr from 'xhr';
import Session from '@nmx/utils/dist/utilities/frontend/session';
import { newRelicJSError } from '@nmx/utils/dist/utilities/frontend/Analytics/new_relic_helper';

export default function GetDynamicConfig(configUrl, sessionKey) {
  return new Promise((resolve, reject) => {
    const dynamicConfigStoredInSession = Session.get(sessionKey);
    if (dynamicConfigStoredInSession) {
      return resolve(JSON.parse(atob(dynamicConfigStoredInSession)));
    }
    xhr({
      method: 'get',
      uri: configUrl,
    }, (err, resp, body) => {
      if (err) {
        newRelicJSError(err);
        return reject(err);
      }
      if (resp.statusCode !== 200) {
        const statusCodeError = `Getting ${sessionKey} resulted in status code: ${resp.statusCode}`;
        newRelicJSError(statusCodeError);
        return reject(statusCodeError);
      }
      Session.set(sessionKey, body);
      return resolve(JSON.parse(atob(body)));
    });
  });
}
